<div class="container">
  <div class="container-inventory">
    <div class="header">
      <h1 class="title">{{'STORE_THEME' | translate}}</h1>
    </div>

    <div class="loading" *ngIf="loading">
      <div class="spinner-border" role="status"></div>
    </div>

     <!-- Header Settings Section -->
    <div class="form-card" *ngIf="!loading">
      <div class="label">
        <div class="label-group">
          <i class="feather" data-feather="layout"></i>
          <strong>{{ isEditingHeaderSettings ? ('SELECT_HEADER_SETTINGS' | translate) : ('HEADER_SETTINGS' | translate) }}</strong>
        </div>
        <div class="label-edit">
          <a class="edit-link" *ngIf="!isEditingHeaderSettings" (click)="switchEditingHeaderSettings()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
          </a>
          <div class="edit-controls" *ngIf="isEditingHeaderSettings">
            <button class="primary-btn" (click)="saveHeaderSettings()">{{'SAVE' | translate}}</button>
            <button class="remove-btn" (click)="cancelEditingHeaderSettings()">{{'CANCEL' | translate}}</button>
          </div>
        </div>
      </div>

      <div class="info-container header-settings-container">
        <!-- Toggle: Search -->
        <div class="header-setting-item">
          <label class="data-label">{{ 'SHOW_SEARCH_BAR' | translate }}</label>
          <span class="data-output" *ngIf="!isEditingHeaderSettings">{{ showSearchBar ? ('YES' | translate) : ('NO' | translate) }}</span>
          <label class="toggle-switch" *ngIf="isEditingHeaderSettings">
            <input type="checkbox" [(ngModel)]="showSearchBar" />
            <span class="toggle-slider"></span>
          </label>
        </div>

        <!-- Toggle: Auth -->
        <div class="header-setting-item">
          <label class="data-label">{{ 'SHOW_AUTH_BUTTONS' | translate }}</label>
          <span class="data-output" *ngIf="!isEditingHeaderSettings">{{ showAuthButtons ? ('YES' | translate) : ('NO' | translate) }}</span>
          <label class="toggle-switch" *ngIf="isEditingHeaderSettings">
            <input type="checkbox" [(ngModel)]="showAuthButtons" />
            <span class="toggle-slider"></span>
          </label>
        </div>

        <!-- Toggle: Cart -->
        <div class="header-setting-item">
          <label class="data-label">{{ 'SHOW_CART' | translate }}</label>
          <span class="data-output" *ngIf="!isEditingHeaderSettings">{{ showCart ? ('YES' | translate) : ('NO' | translate) }}</span>
          <label class="toggle-switch" *ngIf="isEditingHeaderSettings">
            <input type="checkbox" [(ngModel)]="showCart" />
            <span class="toggle-slider"></span>
          </label>
        </div>

        <!-- Language Position -->
        <div class="header-setting-item language-position">
          <label class="data-label">{{ 'LANGUAGE_SELECTOR_POSITION' | translate }}</label>
          <span class="data-output" *ngIf="!isEditingHeaderSettings">{{ languageSelectorPosition === 'navbar' ? 'Navbar' : 'Footer' }}</span>
          <div *ngIf="isEditingHeaderSettings" class="radio-group">
            <label class="radio-option" [class.selected]="languageSelectorPosition === 'navbar'">
              <input type="radio" value="navbar" [(ngModel)]="languageSelectorPosition" name="langPos" />
              <span class="radio-indicator"></span>
              Navbar
            </label>
            <label class="radio-option" [class.selected]="languageSelectorPosition === 'footer'">
              <input type="radio" value="footer" [(ngModel)]="languageSelectorPosition" name="langPos" />
              <span class="radio-indicator"></span>
              Footer
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="form-card" *ngIf="!loading">
      <div class="label">
        <div class="label-group">
          <i class="feather" data-feather="droplet"></i>
          <strong>{{ isEditingColors ? ('SELECT_COLORS' | translate) : ('COLORS' | translate) }}</strong>
        </div>
        <div class="label-edit">
          <a class="edit-link" *ngIf="!isEditingColors" (click)="switchEditingColors()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
          </a>
          <div class="edit-controls">
            <button class="primary-btn" *ngIf="isEditingColors" (click)="updateThemingColors()">{{'SAVE' | translate}}</button>
            <button class="remove-btn" *ngIf="isEditingColors" (click)="cancelEditingColors()">{{'CANCEL' | translate}}</button>
          </div>
        </div>
      </div>
      <div class="info-container">
        <div class="color-container" *ngIf="!isEditingColors">
          <label class="data-label" for="">{{ 'MAIN' | translate }}</label>
          <div class="color-picker">
            <div class="container-image">
              <div class="colorful-svg" [style.--svg-color]="shopMainColor"></div>
              <div class="info-image">
                <img src="https://mobydyg-files.s3.amazonaws.com/mainColorExample" alt="Informative Image">
              </div>
            </div>
            <output class="data-output">{{ shopMainColor }}</output>
          </div>
        </div>
        <div class="editing color-container form-group" *ngIf="isEditingColors">
          <label class="data-label" for="mainColorInput">{{ 'MAIN' | translate }}</label>
        <div class="color-display">
          <input type="color" class="form-control form-control-color" id="mainColorInput" [(ngModel)]="shopMainColor" title="{{'SELECT_COLOR' | translate}}">
          <input type="text" class="form-control" [(ngModel)]="shopMainColor">
        </div>
      </div>
      <div class="color-container" *ngIf="!isEditingColors">
        <label class="data-label" for="">{{ 'PRODUCT_NAME' | translate }}</label>
        <div class="color-picker">
          <div class="container-image">
            <div class="colorful-svg" [style.--svg-color]="shopHeaderColor"></div>
            <div class="info-image">
              <img src="https://mobydyg-files.s3.us-east-1.amazonaws.com/tarjeta-producto.png" alt="Informative Image">
            </div>
          </div>
          <output class="data-output">{{ shopHeaderColor }}</output>
        </div>
      </div>
      <div class="editing color-container form-group" *ngIf="isEditingColors">
        <label class="data-label" for="secondaryColorInput">{{ 'PRODUCT_NAME' | translate }}</label>
        <div class="color-display">
          <input type="color" class="form-control form-control-color" id="secondaryColorInput" [(ngModel)]="shopHeaderColor" title="{{ 'SELECT_COLOR' | translate }}">
          <input type="text" class="form-control" [(ngModel)]="shopHeaderColor">
        </div>
      </div>
        <div class="color-container" *ngIf="!isEditingColors">
          <label class="data-label" for="">Menú</label>
          <div class="color-picker">
            <div class="container-image">
              <div class="colorful-svg" [style.--svg-color]="shopSecondaryColor"></div>
              <div class="info-image">
                <img src="https://mobydyg-files.s3.amazonaws.com/shopSecondaryColorExample" alt="Informative Image">
              </div>
            </div>
            <output class="data-output">{{ shopSecondaryColor }}</output>
          </div>
        </div>
        <div class="editing color-container form-group" *ngIf="isEditingColors">
          <label class="data-label" for="secondaryColorInput">Menú</label>
          <div class="color-display">
            <input type="color" class="form-control form-control-color" id="secondaryColorInput" [(ngModel)]="shopSecondaryColor" title="{{ 'SELECT_COLOR' | translate }}">
            <input type="text" class="form-control" [(ngModel)]="shopSecondaryColor">
          </div>
        </div>

        <div class="color-container" *ngIf="!isEditingColors">
          <label class="data-label" for="">{{ 'HEADER' | translate }}</label>
          <div class="color-picker">
            <div class="container-image">
              <div class="colorful-svg" [style.--svg-color]="shopMainColorDark"></div>
              <div class="info-image">
                <img src="https://mobydyg-files.s3.us-east-1.amazonaws.com/background-header.png" alt="Informative Image">
              </div>
            </div>
            <output class="data-output">{{ shopMainColorDark }}</output>
          </div>
        </div>
        <div class="editing color-container form-group" *ngIf="isEditingColors">
          <label class="data-label" for="shopMainColorDark">{{ 'HEADER' | translate }}</label>
          <div class="color-display">
            <input type="color" class="form-control form-control-color" id="shopMainColorDark" [(ngModel)]="shopMainColorDark" title="{{ 'SELECT_COLOR' | translate }}">
            <input type="text" class="form-control" [(ngModel)]="shopMainColorDark">
          </div>
        </div>
      </div>
    </div>
    
    <div class="form-card" *ngIf="!loading">
      <div class="label">
        <div class="label-group">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="#ea803f" d="M6.4 18h2.1l1.1-3.05h4.8L15.5 18h2.1L13.05 6h-2.1zm3.8-4.8l1.75-4.95h.1l1.75 4.95zM4 22q-.825 0-1.412-.587T2 20V4q0-.825.588-1.412T4 2h16q.825 0 1.413.588T22 4v16q0 .825-.587 1.413T20 22z"/>
          </svg>
          <strong>{{ isEditingFonts ? ('SELECT_FONTS' | translate) : ('FONTS' | translate) }}</strong>
        </div>
        <div class="edit-controls" *ngIf="!isEditingFonts">
          <a (click)="switchEditingFonts()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
          </a>
        </div>
        <div class="edit-controls" *ngIf="isEditingFonts">
          <button class="primary-btn" (click)="saveFont()">{{'SAVE' | translate}}</button>
          <button class="remove-btn" (click)="cancelEditingFonts()">{{'CANCEL' | translate}}</button>
        </div>
      </div>
    
      <div class="font-selector" [class.editing]="isEditingFonts">
        <div class="col-md-4">
          <span class="data-label" *ngIf="!isEditingFonts" [ngStyle]="{'font-family': selectedFont}">
            {{ getSelectedFontName() }}
          </span>
          <select *ngIf="isEditingFonts" [(ngModel)]="selectedFont" (ngModelChange)="onFontChange($event)">
            <option *ngFor="let font of fonts" [value]="font.fontFamily" [ngStyle]="{'font-family': font.fontFamily}">
              {{ font.fontName }}
            </option>
          </select>
        </div>
        <div class="font-preview col-md-8" *ngIf="selectedFont">
          <p [ngStyle]="{'font-family': selectedFont}">
            {{('PREVIEW' | translate)}}: The quick brown fox jumps over the lazy dog
          </p>
        </div>
      </div>
    </div>
    <div class="form-card" *ngIf="!loading">
      <app-favicon></app-favicon>
    </div>
    <div class="form-card" *ngIf="!loading">
      <div class="label">
        <div class="label-group">
          <i class="feather" data-feather="image"></i>
          <strong>{{ 'LOGOS_SECTION_TITLE' | translate }}</strong>
        </div>
        <div class="label-edit">
          <a class="edit-link" *ngIf="!isEditingImages" (click)="switchEditingImages()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
          </a>
          <a class="primary-btn edit-link" *ngIf="isEditingImages" (click)="cancelEditingImages()">{{'CANCEL' | translate}}</a>
          <a class="primary-btn edit-link" *ngIf="isEditingImages" (click)="saveThemingLogo()">{{'SAVE' | translate}}</a>
        </div>
      </div>
      <div class="info-container logos-info-container">
        <div class="info-container logos-info-container-inner">
          <div class="data-container large logo-panels" [class.editing]="isEditingImages" [class.reading]="!isEditingImages">
            <section class="box col-md-4 logo-slot-card">
              <label class="data-label">{{ 'DESKTOP_LOGO' | translate }}</label>
              <div class="logo-slot-preview-surface desktop-navbar-preview preview-frame" [ngStyle]="{'background-color': shopMainColorDark, 'font-family': selectedFont}">
                <div class="desktop-navbar-preview-inner">
                  <div class="preview-navbar-placeholder"></div>
                  <div class="preview-logo-wrapper preview-logo-wrapper--desktop preview-logo-wrapper--compact">
                    <img [src]="getMainLogoPreview()" [attr.alt]="'DESKTOP_LOGO' | translate" class="preview-logo preview-logo--desktop">
                  </div>
                  <div class="preview-navbar-actions">
                    <span class="preview-navbar-chip">A</span>
                    <span class="preview-navbar-chip">B</span>
                  </div>
                </div>
                <div class="preview-menu-strip" [ngStyle]="{'background-color': getMenuPreviewColor()}"></div>
              </div>
              <div class="logo-slot-actions" *ngIf="isEditingImages">
                <input class="form-control form-control-sm logo-upload-input" accept="image/*" type="file" (change)="onMainLogoSelected($event)"/>
                <button type="button" class="logo-guide-trigger" (click)="openLogoGuide('desktop')" data-testid="logo-guide-trigger-desktop">
                  <span class="logo-guide-trigger-icon" aria-hidden="true">i</span>
                  <span>{{ 'LOGO_GUIDE_TRIGGER' | translate }}</span>
                </button>
              </div>
            </section>

            <section class="box col-md-4 logo-slot-card">
              <label class="data-label">{{ 'FOOTER_WHITE_LOGO' | translate }}</label>
              <div class="logo-slot-preview-surface footer-preview-shell preview-frame" [ngStyle]="{'background-color': getFooterPreviewBackground()}">
                <div class="footer-preview-inner">
                  <div class="preview-footer-topline"></div>
                  <div class="preview-logo-wrapper preview-logo-wrapper--footer preview-logo-wrapper--compact">
                    <img [src]="getSecondaryLogoPreview()" [attr.alt]="'FOOTER_WHITE_LOGO' | translate" class="preview-logo preview-logo--footer">
                  </div>
                </div>
              </div>
              <div class="logo-slot-actions" *ngIf="isEditingImages">
                <input class="form-control form-control-sm logo-upload-input" accept="image/*" type="file" (change)="onSecondaryLogoSelected($event)"/>
                <button type="button" class="logo-guide-trigger" (click)="openLogoGuide('footer')" data-testid="logo-guide-trigger-footer">
                  <span class="logo-guide-trigger-icon" aria-hidden="true">i</span>
                  <span>{{ 'LOGO_GUIDE_TRIGGER' | translate }}</span>
                </button>
              </div>
            </section>

            <section class="box col-md-4 logo-slot-card">
              <label class="data-label">{{ 'MOBILE_LOGO' | translate }}</label>
              <div class="logo-slot-preview-surface mobile-navbar-preview preview-frame" [ngStyle]="{'background-color': shopMainColorDark, 'font-family': selectedFont}">
                <div class="mobile-navbar-preview-inner">
                  <span class="mobile-navbar-icon" [ngStyle]="{'color': getMobileIconPreviewColor()}" aria-hidden="true">
                    <svg viewBox="0 0 24 24" role="img" aria-label="menu">
                      <path d="M4 6h16M4 12h16M4 18h16"></path>
                    </svg>
                  </span>
                  <div class="preview-logo-wrapper preview-logo-wrapper--mobile preview-logo-wrapper--compact">
                    <img [src]="getMobileLogoPreview()" [attr.alt]="'MOBILE_LOGO' | translate" class="preview-logo preview-logo--mobile">
                  </div>
                  <span class="mobile-navbar-icon" [ngStyle]="{'color': getMobileIconPreviewColor()}" aria-hidden="true">
                    <svg viewBox="0 0 24 24" role="img" aria-label="cart">
                      <path d="M6 6h15l-2 9H8L6 6Zm0 0L5 3H2"></path>
                      <circle cx="10" cy="20" r="1.5"></circle>
                      <circle cx="17" cy="20" r="1.5"></circle>
                    </svg>
                  </span>
                </div>
                <div class="preview-menu-strip preview-menu-strip--mobile" [ngStyle]="{'background-color': shopMainColorDark}"></div>
              </div>
              <div class="logo-slot-actions" *ngIf="isEditingImages">
                <input class="form-control form-control-sm logo-upload-input" accept="image/*" type="file" (change)="onMobileLogoSelected($event)"/>
                <button type="button" class="logo-guide-trigger" (click)="openLogoGuide('mobile')" data-testid="logo-guide-trigger-mobile">
                  <span class="logo-guide-trigger-icon" aria-hidden="true">i</span>
                  <span>{{ 'LOGO_GUIDE_TRIGGER' | translate }}</span>
                </button>
              </div>
            </section>
          </div>

          <div class="logo-preview-section" *ngIf="isEditingImages">
            <div class="logo-preview-heading">
              <strong>{{ 'LOGO_PREVIEW_SECTION' | translate }}</strong>
              <p class="logo-preview-note">{{ 'LOGO_PREVIEW_APPROX_NOTE' | translate }}</p>
            </div>

            <div class="logo-preview-grid">
              <section class="logo-preview-card logo-preview-card--desktop">
                <div class="logo-preview-card-header">
                  <strong>{{ 'LOGO_PREVIEW_DESKTOP_TITLE' | translate }}</strong>
                </div>
                <div class="desktop-navbar-preview preview-frame" [ngStyle]="{'background-color': shopMainColorDark, 'font-family': selectedFont}">
                  <div class="desktop-navbar-preview-inner">
                    <div class="preview-navbar-placeholder"></div>
                    <div class="preview-logo-wrapper preview-logo-wrapper--desktop">
                      <img [src]="getMainLogoPreview()" [attr.alt]="'DESKTOP_LOGO' | translate" class="preview-logo preview-logo--desktop">
                    </div>
                    <div class="preview-navbar-actions">
                      <span class="preview-navbar-chip">A</span>
                      <span class="preview-navbar-chip">B</span>
                      <span class="preview-navbar-chip">C</span>
                    </div>
                  </div>
                  <div class="preview-menu-strip" [ngStyle]="{'background-color': getMenuPreviewColor()}"></div>
                </div>
                <p class="logo-preview-format" *ngIf="mainLogoFormatNote">{{ mainLogoFormatNote | translate }}</p>
              </section>

              <section class="logo-preview-card logo-preview-card--mobile">
                <div class="logo-preview-card-header">
                  <strong>{{ 'LOGO_PREVIEW_MOBILE_TITLE' | translate }}</strong>
                </div>
                <div class="mobile-navbar-preview preview-frame" [ngStyle]="{'background-color': shopMainColorDark, 'font-family': selectedFont}">
                  <div class="mobile-navbar-preview-inner">
                    <span class="mobile-navbar-icon" [ngStyle]="{'color': getMobileIconPreviewColor()}" aria-hidden="true">
                      <svg viewBox="0 0 24 24" role="img" aria-label="menu">
                        <path d="M4 6h16M4 12h16M4 18h16"></path>
                      </svg>
                    </span>
                    <div class="preview-logo-wrapper preview-logo-wrapper--mobile">
                      <img [src]="getMobileLogoPreview()" [attr.alt]="'MOBILE_LOGO' | translate" class="preview-logo preview-logo--mobile">
                    </div>
                    <span class="mobile-navbar-icon" [ngStyle]="{'color': getMobileIconPreviewColor()}" aria-hidden="true">
                      <svg viewBox="0 0 24 24" role="img" aria-label="cart">
                        <path d="M6 6h15l-2 9H8L6 6Zm0 0L5 3H2"></path>
                        <circle cx="10" cy="20" r="1.5"></circle>
                        <circle cx="17" cy="20" r="1.5"></circle>
                      </svg>
                    </span>
                  </div>
                  <div class="preview-menu-strip preview-menu-strip--mobile" [ngStyle]="{'background-color': shopMainColorDark}"></div>
                </div>
                <p class="logo-preview-format" *ngIf="mobileLogoFormatNote">{{ mobileLogoFormatNote | translate }}</p>
              </section>

              <section class="logo-preview-card logo-preview-card--footer">
                <div class="logo-preview-card-header">
                  <strong>{{ 'LOGO_PREVIEW_FOOTER_TITLE' | translate }}</strong>
                </div>
                <div class="footer-preview-shell preview-frame" [ngStyle]="{'background-color': getFooterPreviewBackground()}">
                  <div class="footer-preview-inner">
                    <div class="preview-footer-topline"></div>
                    <div class="preview-logo-wrapper preview-logo-wrapper--footer">
                      <img [src]="getSecondaryLogoPreview()" [attr.alt]="'FOOTER_WHITE_LOGO' | translate" class="preview-logo preview-logo--footer">
                    </div>
                    <div class="preview-footer-copy">{{ 'LOGO_PREVIEW_FOOTER_LABEL' | translate }}</div>
                  </div>
                </div>
                <p class="logo-preview-format" *ngIf="secondaryLogoFormatNote">{{ secondaryLogoFormatNote | translate }}</p>
              </section>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="logo-guide-modal" *ngIf="isLogoGuideOpen" role="dialog" aria-modal="true" aria-labelledby="logoGuideTitle">
      <button type="button" class="logo-guide-modal__backdrop" [attr.aria-label]="'CLOSE' | translate" (click)="closeLogoGuide()"></button>
      <div class="logo-guide-modal__surface">
        <div class="logo-guide-modal__header">
          <div class="logo-guide-modal__copy">
            <strong id="logoGuideTitle">{{ 'LOGO_GUIDE_MODAL_TITLE' | translate }}</strong>
            <p>{{ 'LOGO_GUIDE_MODAL_SUBTITLE' | translate }}</p>
          </div>
          <button type="button" class="logo-guide-modal__close" (click)="closeLogoGuide()" [attr.aria-label]="'CLOSE' | translate">×</button>
        </div>

        <div class="logo-guide-modal__tabs">
          <button
            type="button"
            class="logo-guide-modal__tab"
            *ngFor="let guideType of logoGuideTypes"
            [class.active]="activeLogoGuide === guideType"
            (click)="setActiveLogoGuide(guideType)">
            {{ guideType === 'desktop' ? ('DESKTOP_LOGO' | translate) : guideType === 'mobile' ? ('MOBILE_LOGO' | translate) : ('FOOTER_WHITE_LOGO' | translate) }}
          </button>
        </div>

        <div class="logo-guide-modal__content" *ngIf="getActiveLogoGuideCard() as activeGuide">
          <div class="logo-guide-modal__section">
            <strong class="logo-guide-modal__section-title">{{ activeGuide.titleKey | translate }}</strong>
            <div class="logo-guide-modal__badges">
              <span class="logo-guide-modal__badge" *ngFor="let badgeKey of activeGuide.badgeKeys">{{ badgeKey | translate }}</span>
            </div>
          </div>

          <div class="logo-guide-modal__section">
            <strong class="logo-guide-modal__section-title">{{ 'LOGO_GUIDE_REFERENCES_TITLE' | translate }}</strong>
            <div class="logo-guide-modal__references">
              <span class="logo-guide-modal__reference" *ngFor="let referenceKey of activeGuide.referenceKeys">{{ referenceKey | translate }}</span>
            </div>
          </div>

          <div class="logo-guide-modal__section">
            <strong class="logo-guide-modal__section-title">{{ 'LOGO_GUIDE_TIPS_TITLE' | translate }}</strong>
            <ul class="logo-guide-modal__tips">
              <li *ngFor="let tipKey of activeGuide.tipKeys">{{ tipKey | translate }}</li>
            </ul>
          </div>

          <div class="logo-guide-modal__section logo-guide-modal__section--notes">
            <p class="logo-guide-modal__note">{{ activeGuide.formatsKey | translate }}</p>
            <p class="logo-guide-modal__note" *ngIf="activeGuide.contrastKey">{{ activeGuide.contrastKey | translate }}</p>
            <p class="logo-guide-modal__note logo-guide-modal__note--accent" *ngIf="activeGuide.performanceKey">{{ activeGuide.performanceKey | translate }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="form-card" *ngIf="!loading">
      <app-menu></app-menu>
    </div>
    <div class="form-card" *ngIf="!loading">
      <app-seo></app-seo>
    </div>
    </div>
  </div>

  <div class="modal category-confirm-modal" id="themingSuccess" tabindex="-1">
    <div class="modal-dialog category-modal-dialog" role="document">
      <div class="modal-content category-modal-content">
        <div class="modal-body category-modal-body">
          <h3 class="text-center">{{ 'CHANGES_SAVED' | translate }}</h3>
          <p class="text-center">{{ 'CHANGES_SAVED_SUCCESS' | translate }}</p>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal category-confirm-modal" id="themingError" tabindex="-1">
    <div class="modal-dialog category-modal-dialog" role="document">
      <div class="modal-content category-modal-content">
        <div class="modal-body category-modal-body">
          <h3 class="text-center">{{'ERROR' | translate}}</h3>
          <p class="text-center">{{'ERROR_SAVING_CHANGES' | translate}}</p>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal category-confirm-modal" id="themingEmpty" tabindex="-1">
    <div class="modal-dialog category-modal-dialog" role="document">
      <div class="modal-content category-modal-content">
        <div class="modal-body category-modal-body">
          <h3 class="text-center">{{ 'NO_CHANGES' | translate }}</h3>
          <p class="text-center">{{ 'NO_CHANGES_TO_SAVE' | translate }}</p>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal category-confirm-modal" id="loadingModal" tabindex="-1">
    <div class="modal-dialog category-modal-dialog" role="document">
      <div class="modal-content category-modal-content">
        <div class="modal-body category-modal-body">
          <h3 class="text-center">{{ 'LOADING' | translate }}</h3>
          <div class="loading">
            <div class="spinner-border" role="status"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
